import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

export function FutureAppointmentsToggle({ showFutureAppointment }) {
  const dispatch = useDispatch();

  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);

  const toggleFutureAppointment = useSelector(
    (state) => state.laser.selectedFilters.toggleFutureAppointment
  );

  const showAppointmentsToggle = showFutureAppointment && startFrom === "leads";

  return showAppointmentsToggle ? (
    <div className="select-box toggle" style={{ width: 130 }}>
      <p className="offers-title">Future Bookings</p>
      <ToggleableButton
        isRadio
        title="future-toggle"
        isActive={toggleFutureAppointment}
        onClick={(val) => dispatch(actionCreators.toggleFutureAppointment(val))}
      />
    </div>
  ) : null;
}
